import React, { useContext } from 'react';
import styles from './Modals.styles';
import { AppContext } from 'App.context';
import bookingNumberImage from '../../../../assets/images/checkin/bookingNumber.svg';
import holderNameImage from '../../../../assets/images/checkin/holderName.svg';
import checkinDateImage from '../../../../assets/images/checkin/checkInDate.svg';

export default function PreviewPaperlessAppearance({ logoImage = null, customStyles = {} }) {
  const {
    appActions: { translate, getSelectedHotel },
  } = useContext(AppContext);
  const hotel = getSelectedHotel();

  const textAndBorderColor = '#000000';
  const {
    backgroundColor = '#fff',
    sectionTitleColor = '#000',
    buttonColor = '#000',
    secondaryColor = '#F5F5F5',
  } = customStyles;

  const iconStyle = {
    ...styles.paperlessIcon,
    color: textAndBorderColor,
    width: 24,
    height: 24,
  };

  return (
    <div
      style={{
        ...styles.paperlessOuterWrapper,
        backgroundColor: backgroundColor,
        padding: 16,
        borderRadius: 16,
      }}
    >
      <div style={styles.paperlessHeaderContainer}>
        <div
          style={{
            ...styles.paperlessBackButton,
            color: textAndBorderColor,
            borderColor: textAndBorderColor,
          }}
        >
          {`< ${translate('common.bookingForm')}`}
        </div>

        <div style={styles.paperlessLogoBox}>
          {logoImage ? (
            <img src={logoImage} alt="logo" style={styles.paperlessLogoImage} />
          ) : (
            <span style={{ fontSize: 24, color: textAndBorderColor }}>+</span>
          )}
        </div>
      </div>

      <div
        style={{
          ...styles.paperlessTitleBar,
          color: sectionTitleColor,
          backgroundColor: secondaryColor,
        }}
      >
        {hotel?.name}
      </div>

      <div style={styles.paperlessInfoBoxContainer}>
        <div
          style={{
            ...styles.paperlessInfoBox,
            border: `1px solid ${textAndBorderColor}`,
          }}
        >
          <img src={bookingNumberImage} alt="booking number" style={iconStyle} />
          <div>
            <div style={{ fontWeight: 'bold', color: textAndBorderColor }}>16122841212</div>
            <div style={styles.paperlessInfoLabel}>{translate('common.bookingCode')}</div>
          </div>
        </div>

        <div
          style={{
            ...styles.paperlessInfoBox,
            border: `1px solid ${textAndBorderColor}`,
          }}
        >
          <img src={holderNameImage} alt="holder name" style={iconStyle} />
          <div>
            <div style={{ fontWeight: 'bold', color: textAndBorderColor }}>
              {translate('common.guestName')}
            </div>
            <div style={styles.paperlessInfoLabel}>{translate('common.holderName')}</div>
          </div>
        </div>

        <div
          style={{
            ...styles.paperlessInfoBox,
            border: `1px solid ${textAndBorderColor}`,
          }}
        >
          <img src={checkinDateImage} alt="check-in date" style={iconStyle} />
          <div>
            <div style={{ fontWeight: 'bold', color: textAndBorderColor }}>20/07/2025</div>
            <div style={styles.paperlessInfoLabel}>{translate('common.entranceDate')}</div>
          </div>
        </div>
      </div>

      <div style={{ ...styles.paperlessSectionTitle, color: sectionTitleColor }}>
        {translate('common.checkInAdults')}
      </div>

      <div
        style={{
          ...styles.paperlessAdultCard,
          border: `1px solid ${textAndBorderColor}`,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <img src={holderNameImage} alt="holder name" style={iconStyle} />
          <span style={{ color: textAndBorderColor }}>{translate('common.guestName')}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={styles.paperlessStatusBadge}>● {translate('common.pending')}</span>
          <button
            style={{
              ...styles.paperlessCheckinButton,
              backgroundColor: secondaryColor,
            }}
          >
            {translate('common.checkIn')}
          </button>
        </div>
      </div>
    </div>
  );
}
